export const destinations = {
    title: "Destinations",
    sortName: "Name",
    noResults: "No results found",
    tryDifferentSearch: "Try a different search"
};
